import {
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  Route,
} from 'react-router-dom';

//
import {
  Documentation,
  FAQElement,
  MaintenancePage,
  Notifications,
} from '@geneo2-web/shared-ui';
import AppLayout from '../../app/Layouts/AppLayout';
import { AnalyticsDashboard } from '../../pages/Analytics/AnalyticsDashboard';
// import { ClassChapterScorePage } from '../../pages/Analytics/ChapterScorePage';
import { ProfileRolesEnum } from '@protos/user_management/ums.db_pb';
import { ServiceClientProvider } from '../../app/Context/ServiceClientsProvider';
import HalfSplitAuthLayout from '../../app/Layouts/HalfSplitAuthLayout';
import { ClassChapterScorePage } from '../../pages/Analytics/ChapterScorePage';
import { ClassScorePage } from '../../pages/Analytics/ClassScorePage';
import { StudentChapterScorePage } from '../../pages/Analytics/StudentScorePage';
import { ChooseProfile } from '../../pages/Auth/Login/ChooseProfile';
import EnterUserIdentification from '../../pages/Auth/Login/EnterUserIdentification';
import { LoginNew } from '../../pages/Auth/Login/LoginNew';
import { ResetPassword } from '../../pages/Auth/Login/ResetPassword';
import { ResetPasswordOtp } from '../../pages/Auth/Login/ResetPasswordOtp';
import { GenericSsoLogin } from '../../pages/Auth/GenericSsoLogin';
import { MCBAppLogin } from '../../pages/Auth/MCBAppLogin/MCBAppLogin';
import { MCBLogin } from '../../pages/Auth/MCBLogin/MCBLogin';
import EnterUserIdRegistration from '../../pages/Auth/Registration/EnterUid';
import { OtpScreen } from '../../pages/Auth/Registration/OtpScreen';
import { SetPassword } from '../../pages/Auth/Registration/SetPassword';
import { VerifyDetails } from '../../pages/Auth/Registration/VerifyDetails';
import { VerifyEmail } from '../../pages/Auth/Registration/VerifyEmail';
import { VerifyPhone } from '../../pages/Auth/Registration/VerifyPhone';
import { StartClassroom } from '../../pages/ConnectedClassRoom/StartClassroom';
import { SelfRegistration } from '../../pages/Auth/SelfRegistration/SelfRegistration';
import { SelfRegistrationForm } from '../../pages/Auth/SelfRegistration/SelfRegistrationForm';
import { UserNameRegistration } from '../../pages/Auth/SelfRegistration/UserNameRegistration';
import Home from '../../pages/Home';
import { SeeAllLessonPlanList } from '../../pages/Home/SeeAllLessonPlanList';

// import { ChapterResourcePage } from '../../pages/Homework/ChapterResourcepage';

// import TopicSelection from '../../pages/Homework/TopicSelection';
import { CompletedHomework } from '../../pages/ManageHomework/CompletedHomework';
import { HwPerformance } from '../../pages/ManageHomework/HwPerformance';
import AssesmentLibrary from '../../pages/Assessment/AssesmentLibrary';
import { ManageHomework } from '../../pages/ManageHomework/ManageHomeworkHome';
import { OngoingHomework } from '../../pages/ManageHomework/OngoingHomework';
import { SubmissionCustomHw } from '../../pages/ManageHomework/SubmissionCustomHw';
import DownloadSettings from '../../pages/OfflineScreens/Teach/DownloadSettings';
import { LessonPlanListOffline } from '../../pages/OfflineScreens/Teach/LessonPlanLists';
import { ResourcePageOffline } from '../../pages/OfflineScreens/Teach/ResourcePage';
import OfflineTeachChapterSelection from '../../pages/OfflineScreens/Teach/TeachChapterSelection';
import TeachingFlowOffline from '../../pages/OfflineScreens/Teach/TeachingFlow';
import TeachTopicSelectionOffline from '../../pages/OfflineScreens/Teach/TeachTopicSelection';
import { ChangePassword } from '../../pages/Sidebar/ChangePassword';
import { HelpAndSupport } from '../../pages/Sidebar/HelpAndSupport';
import { Profile } from '../../pages/Sidebar/Profile';
import { ProfileOtpScreen } from '../../pages/Sidebar/ProfileOtpScreen';
import { TeacherDisclaimer } from '../../pages/Sidebar/TeacherDisclaimer';
import AddResources from '../../pages/Teach/AddResources';
import EditLessonPlan from '../../pages/Teach/EditLessonPlan';
import LessonPlanLists from '../../pages/Teach/LessonPlanLists';
import ReplaceResources from '../../pages/Teach/ReplaceResources';
import { ResourcePage } from '../../pages/Teach/ResourcePage';
import { ResourceUpload } from '../../pages/Teach/ResourceUpload';
import TeachChapterSelection from '../../pages/Teach/TeachChapterSelection';
import TeachingFlow from '../../pages/Teach/TeachingFlow';
import TeachTopicSelection from '../../pages/Teach/TeachTopicSelection';
import {
  ADD_RESOURCES,
  ANALYTICS_CHAPTER_SCORE,
  ANALYTICS_CLASS_SCORE,
  ANALYTICS_CLASS_SELECTION,
  ANALYTICS_STUDENT_SCORE,
  CHANGE_PASSWORD,
  CHOOSE_PROFILE,
  CONNECTED_CLASS_RESULTS,
  DISCLAIMER,
  DOCS,
  DOWNLOAD_SETTINGS,
  EDIT_LESSON_PLAN,
  ENTER_UID,
  FAQ,
  HELP,
  HOME,
  ASSESSMENT_ASSIGN,
  HOMEWORK_CHAPTER_SELECTION,
  HOMEWORK_COMPLETED,
  HOMEWORK_MANAGE,
  ASSESMENT_LIBRARY,
  HOMEWORK_ONGOING,
  HOMEWORK_PERFORMANCE,
  HOMEWORK_SUBMISSION_CUSTOM,
  HOMEWORK_TOPIC_SELECTION,
  LESSON_PLAN_LISTS,
  LOGIN,
  LOGIN_PASSWORD,
  MCB_APP_LOGIN,
  MCB_LOGIN,
  NOTIFICATION,
  OFFLINE_LESSON_PLAN_LISTS,
  OFFLINE_RESOURCE,
  OFFLINE_TEACH_CHAPTER_SELECTION,
  OFFLINE_TEACH_TOPIC_SELECTION,
  OFFLINE_TEACHING_FLOW,
  OTP_SCREEN,
  PROFILE,
  PROFILE_OTP_SCREEN,
  REGISTRATION,
  REPLACE_RESOURCE,
  RESET_PASSWORD,
  RESET_PASSWORD_OTP,
  RESOURCE_PAGE,
  SEEALL_LESSON_PLAN_LIST,
  RESOURCE_UPLOAD,
  SELF_REGISTRATION,
  SELF_REGISTRATION_FORM,
  SET_PASSWORD,
  START_CLASSROOM,
  TEACH_CHAPTER_SELECTION,
  TEACH_TOPIC_SELECTION,
  TEACHING_FLOW,
  USER_NAME_REGISTRATION,
  VERIFY_DETAILS,
  VERIFY_EMAIL,
  VERIFY_PHONE,
  SWITCH_PROFILE,
  HOMEWORK,
  ASSESSMENT_CURRENT,
  ASSESSMENT_CREATE,
  HOMEWORK_CURRENT_CUSTOM,
  ASSESSMENT_VIEW,
  ASSESSMENT_CONGRATULATIONS,
  HOMEWORK_CREATE,
  HOMEWORK_ASSIGN,
  HOMEWORK_CURRENT,
  HOMEWORK_CONGRATULATIONS,
  FORMATIVE,
  DIAGNOSTIC,
  REPORT,
  CLICKER_ASSESSMENT_MANAGE,
  CLICKER_ASSESSMENT_START,
  CLICKER_ASSESSMENT,
  ASSESSMENT_REVIEW,
  QPG,
  ASSESSMENT_QUESTIONBANK,
  QUESTION_PAPERS_LIST,
  QPG_ASSESSMENT_REVIEW,
  QPG_ASSESSMENT_QUESTION_BANK,
  QPG_ASSESSMENT_CREATE,
  DEMO_FORMATIVE_QPG,
  SCREEN_RESOLVER,
  SSO_REDIRECT,
  QPG_ASSESSMENT_PUBLISH,
  QPG_ASSESSMENT_PUBLISHED,
  QPG_ASSESSMENT_REVIEW_PAPER,
  QPG_ASSESSMENT_CREATION,
  QPG_QUESTION_BANK,
  QPG_PREVIEW,
  QUESTION_BANK,
  FA_DRAFT,
  FA_CREATION,
  FA_REVIEW,
  FA_QUESTION_BANK,
  FA_ASSIGN_SETTINGS,
  FA_PREVIEW,
  OMR_ACTIVE,
} from '../RoutesNomenclature';
import PrivateRouterWrapper from './PrivateRoutersWrapper';

import { ConnectedClassResults } from '../../pages/ConnectedClassRoom/ResultsPage';
import HwChapterSelection from '../../pages/Assessment/Homework/HwChapterSelection';
import HwTopicSelection from '../../pages/Assessment/Homework/TopicSelection';
import { AssignAssessment } from '../../pages/Assessment/Common/AssignAssessment';

import { CongratulationsPage } from '../../pages/Assessment/Common/CongratulationsPage';
import CurrentAssessment from '../../pages/Assessment/Common/CurrentAssessment';
import { CreateAssessment } from '../../pages/Assessment/Common/CreateAssessment';
import { CreateCustomHomework } from '../../pages/Assessment/Homework/CreateCustomHomework';
import { ViewAssessment } from '../../pages/Assessment/Common/ViewAssessment';
import { Reports } from '../../pages/Reports';
import { ForamtiveAssessmentCreate } from '../../pages/Assessment/FormativeAssessment/AssessmentCreate';
import { ClickerAssessmentStart } from '../../pages/Assessment/ClickerAssessment/ClickerAssessmentStart';
import { ClickerAssessmentManage } from '../../pages/ManageHomework/ClickerAssessmentManage';
import ClickerAssessment from '../../pages/Assessment/ClickerAssessment';
import { QuestionPaperCreate } from '../../pages/Assessment/QuestionPaperGenerator/QuestionPaperCreate';
import ReviewQuestionPaper from '../../pages/Assessment/QuestionPaperGenerator/ReviewQuestionPaper';
import SearchQuestions from '../../pages/Assessment/QuestionPaperGenerator/SearchQuestions';
import { PreviousYearQPList } from '../../pages/Home/QuestionPapers/PreviousYearQPList';
import DemoFormativeQPG from '../../pages/Demo/FormativeQPG';
import { RouteErrorBoundary } from '../../components/RouteErrorBoundary';
import { ScreenResolver } from '../../pages/Demo/ScreenResolver';
import { QPGPublish } from '../../pages/Assessment/QuestionPaperGeneratorV2/QPGPublish';
import { QPGPublished } from '../../pages/Assessment/QuestionPaperGeneratorV2/QPGPublished';
import { QPGReviewPaper } from '../../pages/Assessment/QuestionPaperGeneratorV2/QPGReviewPaper';
import { QPGCreation } from '../../pages/Assessment/QuestionPaperGeneratorV2/QPGCreation';
import { QPGQuestionBank } from '../../pages/Assessment/QuestionPaperGeneratorV2/QPGReviewPaper/components/QPGQuestionBank';
import { QPGPreview } from '../../pages/Assessment/QuestionPaperGeneratorV2/QPGPreview';
import QuestionBank from '../../pages/ManageHomework/QuestionBank';
import { FADraft } from '../../pages/Assessment/FormativeAssessmentV2/FADraft';
import { FACreation } from '../../pages/Assessment/FormativeAssessmentV2/FACreation';
import { FAReview } from '../../pages/Assessment/FormativeAssessmentV2/FAReview';
import { FAQuestionBank } from '../../pages/Assessment/FormativeAssessmentV2/FAReview/components/FAQuestionBank';
import { FAAssignSettings } from '../../pages/Assessment/FormativeAssessmentV2/FAAssignSettings';
import { FAPreview } from '../../pages/Assessment/FormativeAssessmentV2/FAPreview';
import { OmrActive } from '../../pages/Assessment/OmrAssessment/OmrActive';

export const router = createBrowserRouter(
  createRoutesFromElements(
    <Route
      path="/"
      element={<ServiceClientProvider />}
      errorElement={<RouteErrorBoundary />}
    >
      <Route
        path="/maintenance"
        element={<MaintenancePage homePath={HOME} />}
      />
      {/* //! ------------- A U T H ------------- */}
      <Route path="/" element={<HalfSplitAuthLayout />}>
        <Route path={'/'} element={<Navigate to={ENTER_UID} replace />} />
        <Route path={LOGIN} element={<Navigate to={ENTER_UID} replace />} />
        <Route path={ENTER_UID} element={<EnterUserIdentification />} />
        <Route path={VERIFY_PHONE} element={<VerifyPhone />} />
        <Route path={VERIFY_EMAIL} element={<VerifyEmail />} />
        <Route path={OTP_SCREEN} element={<OtpScreen />} />
        <Route path={LOGIN_PASSWORD} element={<LoginNew />} />
        <Route path={VERIFY_DETAILS} element={<VerifyDetails />} />
        <Route path={SET_PASSWORD} element={<SetPassword />} />
        <Route path={RESET_PASSWORD} element={<ResetPassword />} />
        <Route path={RESET_PASSWORD_OTP} element={<ResetPasswordOtp />} />
        <Route path={REGISTRATION} element={<EnterUserIdRegistration />} />
        <Route path={SELF_REGISTRATION} element={<SelfRegistration />} />
        <Route
          path={USER_NAME_REGISTRATION}
          element={<UserNameRegistration />}
        />
        <Route
          path={SELF_REGISTRATION_FORM}
          element={<SelfRegistrationForm />}
        />
      </Route>
      <Route path={MCB_LOGIN} element={<MCBLogin />} />
      <Route path={MCB_APP_LOGIN} element={<MCBAppLogin />} />
      <Route
        path={SSO_REDIRECT + '/:external_client'}
        element={<GenericSsoLogin />}
      />
      <Route path={CHOOSE_PROFILE} element={<ChooseProfile />} />
      <Route path={SWITCH_PROFILE} element={<ChooseProfile />} />
      <Route path={SCREEN_RESOLVER} element={<ScreenResolver />} />

      {/*//! ---------------- A P P L I C A T I O N ----------------------- */}
      <Route path="/" element={<AppLayout />}>
        <Route element={<PrivateRouterWrapper />}>
          <Route path="/" element={<Navigate to={HOME} replace />} />
          <Route path={HOME} element={<Home />} />

          <Route
            path={SEEALL_LESSON_PLAN_LIST}
            element={<SeeAllLessonPlanList />}
          />
          {/* <Route path="/header" element={<HeaderMidLogo />} /> */}
          <Route path={QUESTION_PAPERS_LIST} element={<PreviousYearQPList />} />

          {/*//! ----------- N E W - H O M E W O R K--------------- */}
          <Route
            path={`${HOMEWORK_CHAPTER_SELECTION}/:subject_id`}
            element={<HwChapterSelection />}
          />
          <Route
            path={`${HOMEWORK_TOPIC_SELECTION}/:subject_id/:chapter_id`}
            element={<HwTopicSelection />}
          />
          <Route
            path={`${ASSESSMENT_CONGRATULATIONS}/:assessmentId`}
            element={<CongratulationsPage />}
          />
          {/* submission-custom-hw */}
          <Route
            path={`${HOMEWORK_SUBMISSION_CUSTOM}/:student_id`}
            element={<SubmissionCustomHw />}
          />
          <Route
            path={`${HOMEWORK}${ASSESSMENT_CREATE}/:module_id/:chapter_id`}
            element={<CreateAssessment />}
          />
          {/* Assessment Assign Screens */}
          <Route
            path={`${HOMEWORK}${ASSESSMENT_ASSIGN}`}
            element={<AssignAssessment />}
          />
          <Route
            path={`${FORMATIVE}${ASSESSMENT_ASSIGN}`}
            element={<AssignAssessment />}
          />
          <Route
            path={`${FORMATIVE}${ASSESSMENT_CREATE}/:subject_id`}
            element={<ForamtiveAssessmentCreate />}
          />
          <Route
            path={`${DIAGNOSTIC}${ASSESSMENT_ASSIGN}`}
            element={<AssignAssessment />}
          />
          {/* Current Assessment Screens */}
          <Route
            path={`${HOMEWORK}${ASSESSMENT_CURRENT}/:module_id`}
            element={<CurrentAssessment />}
          />
          <Route
            path={`${FORMATIVE}${ASSESSMENT_CURRENT}/:module_id`}
            element={<CurrentAssessment />}
          />
          <Route
            path={`${FORMATIVE}${ASSESSMENT_CURRENT}`}
            element={<CurrentAssessment />}
          />
          <Route
            path={`${DIAGNOSTIC}${ASSESSMENT_CURRENT}/:module_id`}
            element={<CurrentAssessment />}
          />
          {/* <Route
            path={`${HOMEWORK}${ASSESSMENT_CONGRATULATIONS}/:homeworkId`}
            element={<CongratulationsPage />}
          /> */}
          {/* current-custom-homework */}
          <Route
            path={`${HOMEWORK}${HOMEWORK_CURRENT_CUSTOM}/:module_id`}
            element={<CreateCustomHomework />}
          />
          <Route
            path={`${QPG_ASSESSMENT_CREATE}/:subject_id`}
            element={<QuestionPaperCreate />}
          />
          <Route
            path={`${QPG_ASSESSMENT_REVIEW}/:assessment_id`}
            element={<ReviewQuestionPaper />}
          />
          <Route
            path={`${QPG_ASSESSMENT_QUESTION_BANK}`}
            element={<SearchQuestions />}
          />

          {/* QPG V2 */}
          <Route path={QPG_ASSESSMENT_PUBLISH} element={<QPGPublish />} />
          <Route path={QPG_ASSESSMENT_PUBLISHED} element={<QPGPublished />} />
          <Route path={QPG_ASSESSMENT_CREATION} element={<QPGCreation />} />
          <Route
            path={QPG_ASSESSMENT_REVIEW_PAPER}
            element={<QPGReviewPaper />}
          />
          <Route path={QPG_QUESTION_BANK} element={<QPGQuestionBank />} />
          <Route path={QPG_PREVIEW} element={<QPGPreview />} />

          {/* FA V2 */}
          <Route path={FA_DRAFT} element={<FADraft />} />
          <Route path={FA_CREATION} element={<FACreation />} />
          <Route path={FA_REVIEW} element={<FAReview />} />
          <Route path={FA_QUESTION_BANK} element={<FAQuestionBank />} />
          <Route path={FA_ASSIGN_SETTINGS} element={<FAAssignSettings />} />
          <Route path={FA_PREVIEW} element={<FAPreview />} />
          {/* <Route path={QPG_ASSESSMENT_TEST_CREATION} element={<QPGCreation />} /> */}

          {/*//! ----------- M A N A G E - H O M E W O R K--------------- */}
          <Route path={HOMEWORK_MANAGE} element={<ManageHomework />} />
          <Route path={ASSESMENT_LIBRARY} element={<AssesmentLibrary />} />
          <Route path={`${HOMEWORK_ONGOING}`} element={<OngoingHomework />} />
          <Route
            path={`${HOMEWORK_COMPLETED}`}
            element={<CompletedHomework />}
          />
          <Route
            path={`${HOMEWORK_PERFORMANCE}/:student_id`}
            element={<HwPerformance />}
          />
          <Route path={QUESTION_BANK} element={<QuestionBank />} />
          {/* <Route path={ASSESSMENT_VIEW} element={<ViewAssessment />} /> */}

          <Route
            path={`${ASSESSMENT_VIEW}/assigned`}
            element={<ViewAssessment status="assigned" />}
          />
          <Route
            path={`${ASSESSMENT_VIEW}/ended`}
            element={<ViewAssessment status="ended" />}
          />
          <Route
            path={`${OMR_ACTIVE}/:assessment_id`}
            element={<OmrActive />}
          />

          {/* //! ---------- C L I C K E R - A S S E S S M E N T ---------- */}
          <Route
            path={CLICKER_ASSESSMENT_MANAGE}
            element={<ClickerAssessmentManage />}
          />
          <Route
            path={CLICKER_ASSESSMENT_START}
            element={<ClickerAssessmentStart />}
          />
          <Route path={CLICKER_ASSESSMENT} element={<ClickerAssessment />} />

          {/* //! ------------- A N A L Y T I C S ------------- */}
          <Route
            path={ANALYTICS_CLASS_SELECTION}
            element={<AnalyticsDashboard />}
          />
          <Route path={ANALYTICS_CLASS_SCORE} element={<ClassScorePage />} />
          <Route
            path={ANALYTICS_CHAPTER_SCORE}
            element={<ClassChapterScorePage />}
          />
          <Route
            path={ANALYTICS_STUDENT_SCORE}
            element={<StudentChapterScorePage />}
          />

          {/* //! ------------- T E A C H ------------- */}
          <Route
            path={`${TEACH_CHAPTER_SELECTION}/:subject_id`}
            element={<TeachChapterSelection />}
          />
          <Route
            path={`${TEACH_TOPIC_SELECTION}/:subject_id/:chapter_id`}
            element={<TeachTopicSelection />}
          />
          <Route
            path={`${LESSON_PLAN_LISTS}/:subject_id/:chapter_id/:topic_id`}
            element={<LessonPlanLists />}
          />
          {/*  ----------- Connected-classroom--------------- */}
          <Route
            path={`${START_CLASSROOM}/:subject_id/:topic_id/:lesson_id`}
            element={<StartClassroom />}
          />

          <Route
            path={CONNECTED_CLASS_RESULTS}
            element={<ConnectedClassResults />}
          />
          <Route
            // path={`${TEACHING_FLOW}/:lesson_id`}
            path={`${TEACHING_FLOW}/:subject_id/:chapter_id/:topic_id/:lesson_id`}
            element={<TeachingFlow />}
          />

          <Route
            // path={`${EDIT_LESSON_PLAN}/:lesson_id`}
            path={`${EDIT_LESSON_PLAN}/:subject_id/:chapter_id/:topic_id/:lesson_id`}
            element={<EditLessonPlan />}
          />

          <Route
            path={`${ADD_RESOURCES}/:subject_id/:chapter_id/:topic_id/:lesson_id/:resource_index`}
            element={<AddResources />}
          />

          <Route
            path={`${REPLACE_RESOURCE}/:subject_id/:chapter_id/:topic_id/:lesson_id/:resource_index`}
            element={<ReplaceResources />}
          />

          <Route path={`${RESOURCE_PAGE}`} element={<ResourcePage />} />

          {/* <Route
            path={'/chapter-resource-page'}
            element={<ChapterResourcePage />}
          /> */}
          <Route
            path={`${RESOURCE_UPLOAD}/:resource_id/`}
            element={<ResourceUpload />}
          />

          {/* //!--------------OFFLINE SCREENS------------- */}
          <Route
            path={`${OFFLINE_TEACH_CHAPTER_SELECTION}/:subject_id`}
            element={<OfflineTeachChapterSelection />}
          />
          <Route
            path={`${OFFLINE_TEACH_TOPIC_SELECTION}/:subject_id/:chapter_id`}
            element={<TeachTopicSelectionOffline />}
          />
          <Route
            path={`${OFFLINE_LESSON_PLAN_LISTS}/:subject_id/:chapter_id/:topic_id`}
            element={<LessonPlanListOffline />}
          />
          <Route
            path={`${OFFLINE_TEACHING_FLOW}/:subject_id/:chapter_id/:topic_id/:lesson_plan_id`}
            element={<TeachingFlowOffline />}
          />
          <Route
            path={`${OFFLINE_RESOURCE}/:subject_id/:chapter_id/:topic_id/:lesson_plan_id/:resource_id`}
            element={<ResourcePageOffline />}
          />
          <Route path={`${DOWNLOAD_SETTINGS}`} element={<DownloadSettings />} />

          {/* //!--------------SIDEBAR------------- */}
          <Route path={PROFILE} element={<Profile />} />
          <Route path={PROFILE_OTP_SCREEN} element={<ProfileOtpScreen />} />

          {/* //-------------------DEMO------------- */}
          <Route path={DEMO_FORMATIVE_QPG} element={<DemoFormativeQPG />} />
        </Route>
        <Route path={CHANGE_PASSWORD} element={<ChangePassword />} />
        <Route path={`${NOTIFICATION}`} element={<Notifications />} />
        <Route path={`${HELP}`} element={<HelpAndSupport />} />
        <Route
          path={`${FAQ}`}
          element={<FAQElement role={ProfileRolesEnum.PROFILE_ROLE_TEACHER} />}
        />
        <Route path={`${DISCLAIMER}`} element={<TeacherDisclaimer />} />
        <Route path={REPORT} element={<Reports />} />
      </Route>
      <Route path={DOCS} element={<Documentation />} />
    </Route>
  )
);
